/* global tns */
// eslint-disable-next-line no-unused-vars
/* global Tollwerk */
(function iife(d) {
    // eslint-disable-next-line no-unreachable
    const sliders = d.querySelectorAll('.Slider');

    sliders.forEach((thisSlider) => {
        const items = thisSlider.querySelector('.Slider__items');
        const prev = thisSlider.querySelector('.Slider__control--prev');
        const next = thisSlider.querySelector('.Slider__control--next');
        const nav = thisSlider.querySelector('.Slider__nav');
        // Loop by default, only data-loop="false" switches it off (same as the deployed build)
        const doesloop = thisSlider.getAttribute('data-loop') !== 'false';

        tns({
            container: items,
            navContainer: nav,
            prevButton: prev,
            nextButton: next,
            items: 1,
            slideBy: 'page',
            touch: true,
            mouseDrag: true,
            swipeAngle: 25,
            preventScrollOnTouch: 'auto',
            autoHeight: thisSlider.dataset.autoHeight === 'true',
            autoWidth: true,
            rewind: false,
            loop: doesloop,
            edgePanning: 100,
            lazyload: thisSlider.dataset.lazyload === 'true',
        });
    });
}(document));
